import { useTranslation } from 'react-i18next';
import Table from 'lqa-ui/lib/Components/Table';
import TableHead from 'lqa-ui/lib/Components/TableHead';
import TableHeadCell from 'lqa-ui/lib/Components/TableHeadCell';
import TableRow from 'lqa-ui/lib/Components/TableRow';
import TableRowCell from 'lqa-ui/lib/Components/TableRowCell';
import React from 'react';
// import { TutorialModalView } from './TutorialModalView';
// import TutorialContext from './TutorialContext';
import { useHistory } from 'react-router-dom';
import { useRequestWithAuth } from '../../hooks/useRequestWithAuth';
import { useSelector } from 'react-redux';
import NonIdealState from 'lqa-ui/lib/Components/NonIdealState';
import { ResponseStatusEnum } from '../../enums/ResponseStatus';
import LoadingApp from 'lqa-ui/lib/Components/LoadingApp';
import { getTutorialVideos, onlineTrainingSelector } from 'screens/onlineTraining/mytraining.queries';

export const TutorialVideoList = (props) => {
    const { t } = useTranslation();
    const {setTutorialVideoOpenOverlay} = props;
    const history = useHistory();
    const [modal, setVideoModal] = React.useState<boolean>(false);
    // const useTutorialContext = React.useContext(TutorialContext);
    const [videoUrl, setVideoUrl] = React.useState<string | undefined>(undefined);
    const [{status: queryStatus}] = useRequestWithAuth({
        ...getTutorialVideos(),
        force: true,
    });

    const response = useSelector(onlineTrainingSelector);
    const tutorialVideo = response!.tutorialVideo;
    if (tutorialVideo === undefined) {
        if (!!queryStatus && queryStatus !== ResponseStatusEnum.ok) {
            return <NonIdealState title={t('general.Something went wrong')} />;
        }
        return <LoadingApp />;
    }

    return (
        <React.Fragment>
           {modal && videoUrl &&  <>
            <div
                className="iframe"
                style={{
                    padding: '56.25% 0 0 0',
                    position: 'relative',
                }}
            >
                <video 
                    controlsList="nodownload"
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                    }}
                    autoPlay={true} controls={true}
                >
                    <source src={videoUrl} type="video/mp4" />
                </video>
                {/* <iframe
                    src={videoUrl}
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                    }}
                    frameBorder="0"
                    allow="autoplay; fullscreen"
                    allowFullScreen={true}
                /> */}
            </div>
           
        </>}
            <Table >
                <TableHead >
                    <TableHeadCell
                        priority={1}
                        width={100}
                    >
                        {''}
                    </TableHeadCell>
                    <TableHeadCell
                        priority={1}
                        width={500}
                    />                    
                </TableHead>

                {tutorialVideo.map
                ( (o, i) => <TableRow key={i} 
                    onClick={() => {                        
                        setVideoModal(true);
                        setVideoUrl(o.videoUrl);
                        history.push({hash: 'module'});
                }}
                     >
                    <TableRowCell   >
                        <img height={80} width={80} src={o.pictureUrl} />
                    </TableRowCell>
                    <TableRowCell className={'charts'}> {o.name}</TableRowCell>
                </TableRow>)
                }
            </Table>
        </React.Fragment>
    );
};
